export default "__VITE_ASSET__acfe3f5b__"